import axios, { AxiosRequestConfig, Canceler } from 'axios';

import { getAppVersion, getConfig } from '@constants';

import { getAccessToken, getClientId, getPlatform } from '@utils';

function isForeign(url: string) {
	const urlHost = url.includes('//') && url.substring(url.indexOf('//'), url.indexOf('/', 9));
	const { hosts: { api: apiHost } } = getConfig();

	return urlHost &&
		urlHost !== location.host &&
		urlHost !== apiHost;
}

export class BrowserHttpTransport {

	static axios: typeof axios = axios;

	static setup() {
		const { hosts: { api } } = getConfig();

		axios.defaults.baseURL = api;

		this.setUnregHeaders();
		this.setAuthorizationHeader();
	}

	static async http(params: AxiosRequestConfig & { getAbort?(abort: Canceler): void }) {
		return axios({
			// eslint-disable-next-line import/no-named-as-default-member
			cancelToken: new axios.CancelToken((abort: Canceler) => params.getAbort && params.getAbort(abort)),
			...params,
		});
	}

	private static setUnregHeaders() {
		axios.interceptors.request.use((config: AxiosRequestConfig) => {
			const appVersion = getAppVersion();

			if (isForeign(config.url)) {
				return config;
			}

			const headers = { ...config.headers };

			return {
				...config,
				headers: {
					...headers,
					['X-From']: getClientId(),
					['X-App-Id']: `web-view:${getPlatform()}`,
					...(appVersion ? { ['X-Client-Version']: appVersion } : {}),
				},
			};
		});
	}

	private static setAuthorizationHeader() {
		axios.interceptors.request.use((config: AxiosRequestConfig) => {
			if (isForeign(config.url) || !getAccessToken()) {
				return config;
			}

			const headers = { ...config.headers };

			return {
				...config,
				headers: {
					...headers,
					['Authorization']: `Bearer ${getAccessToken()}`,
				},
			};
		});
	}

}
